// @ts-strict-ignore
import { AfterViewInit, Component, Input, OnInit, ViewContainerRef, EventEmitter, Output } from '@angular/core';
import { LandmarkPanel } from '@form/lm-form.model';
import { LMModel } from '@form/model/lm-model';
import { LMFormState } from '@states/models/lm-form-state.model';
import { LMFormPersonalization } from '@states/models/lm-form-personalization.model';

@Component({
  selector:    'lm-form-content-menu', // tslint:disable-line
  standalone: false,
  templateUrl: 'lm-form-content-menu.component.html'
})

export class LMFormContentMenuComponent implements AfterViewInit, OnInit {

  @Input() layout: LMMenuPanelLayout;
  @Input() formOptions;
  @Input() specFields: LMSpecFields;
  @Input() formSpec: LMFormSpec = null;
  @Input() model: LMModel;
  @Input() formState: LMFormState;
  @Input() placeHolder: ViewContainerRef;
  @Input() formPersonalization: LMFormPersonalization;

  @Output() fieldEvent: EventEmitter<LMFieldEvent> = new EventEmitter<LMFieldEvent>();

  public panels: Array<LandmarkPanel>;

  constructor() {
  }

  ngAfterViewInit() {
  }

  ngOnInit() {
  }

  onFieldEvent(event) {
    this.fieldEvent.emit(event);
  }
}
